.ux-cookie-layer-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    pointer-events: auto;
    position: fixed;
    z-index: 5000;
    padding: 10px;
    box-sizing: border-box;
    overflow: hidden;

    &.ux-cookie-layer-modal--sticky-bottom {
        justify-content: flex-end;
    }

    &.ux-cookie-layer-modal--sticky-top {
        justify-content: flex-start;
    }

    @media (max-width: $breakpoint-tablet - 1) {
        align-items: stretch;
    }

    @media (max-width: $breakpoint-mobile - 1) {
        justify-content: flex-end;
        align-items: stretch;
    }

    @media (min-width: $breakpoint-desktop) {
        padding: 15px;
    }

    &--closed {
        display: none;
    }

    &__backdrop {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, var(--ux-cookie-layer-backdrop-opacity));

        .ux-cookie-layer-modal--opening & {
            opacity: 0;
        }

        .ux-cookie-layer-modal--opened & {
            opacity: 1;
            transition: opacity 250ms ease-out;
        }

        .ux-cookie-layer-modal--closing & {
            opacity: 0;
            transition: opacity 250ms ease-out;
        }

        .ux-cookie-layer-modal--closed & {
            opacity: 0;
        }
    }

    &__outer {
        display: flex;
        position: relative;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;

        @media (min-width: $breakpoint-tablet) {
            width: 83.3333%;
        }

        @media (min-width: $breakpoint-desktop) {
            width: 66.6666%;
            max-width: 960px;
        }
    }

    &__inner {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;
        background: var(--ux-cookie-layer-bg-color);
        width: 100%;
        max-height: 100%;
        box-shadow: var(--ux-cookie-layer-modal-shadow);

        .ux-cookie-layer-modal--opening & {
            transform: scale(0.95);
            opacity: 0;
        }

        .ux-cookie-layer-modal--opened & {
            transform: none;
            opacity: 1;
            transition: opacity 250ms ease-out, transform 250ms ease-out;
        }

        .ux-cookie-layer-modal--closing & {
            transform: scale(0.95);
            opacity: 0;
            transition: opacity 250ms ease-out, transform 250ms ease-out;
        }

        .ux-cookie-layer-modal--closed & {
            transform: scale(0.95);
        }
    }

    &__head {
        flex: 0 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        height: 40px;
    }

    &__slot {
        flex: 1 1 auto;
        display: flex;
        width: 100%;
        max-height: calc(100% - 40px);
        flex-direction: column;
        align-items: stretch;
        justify-content: stretch;
    }

    &__close {
        appearance: none;
        background: transparent;
        border: 0 none transparent;
        padding: 0;
        margin: 0;
        outline: none;
        cursor: pointer;
        width: 40px;
        height: 40px;

        &-svg {
            display: block;
            width: 100%;
            height: 16px;
        }
    }
}
